const modals = {
  Total: 0,
  TableListData: [], //table数据
  tableLoading: false,
  SerchParameters: {
    pageNum: 1,
    pageSize: 10,
  },
};

export default modals;
